import { render, staticRenderFns } from "./contact-new.vue?vue&type=template&id=0f47813f&"
import script from "./contact-new.vue?vue&type=script&lang=js&"
export * from "./contact-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports